import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {AccountService} from '../../services/account.service';
import {AgreementType} from '../../models/enums';
import {IDirectoryAgreement} from '../../models/domain';
import { coerceBooleanProperty } from '@angular/cdk/coercion';


@Component({
    selector: 'app-user-agreement',
    templateUrl: './userAgreement.component.html',
    styleUrls: ['./userAgreement.component.scss']
})
export class UserAgreementComponent implements OnInit, AfterViewInit {

    private _returnUrl: string;
    private _agreementType: AgreementType;
    private _userTicket: string;
    private _isAuthorized: boolean = false;

    constructor(
        private _translateService: TranslateService,
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _accountService: AccountService,
    ) {

    }

    @ViewChild("userAgreementContainer") userAgreementContainer: ElementRef;

    public agreement: IDirectoryAgreement;

    ngOnInit(): void {

        this._returnUrl = this._activatedRoute.snapshot.queryParamMap.get("ReturnUrl");
        this.initAgreementType();

        this._activatedRoute.data.subscribe(({ isAuthorized }: { isAuthorized: boolean }) => {
            this._isAuthorized = isAuthorized;
        })

        if (!this._returnUrl) {
            this._returnUrl = './login';
        }
    }

    ngAfterViewInit(): void {
        this.getAgreement();
    }
    initAgreementType(){
        this._agreementType = +this._activatedRoute.snapshot.queryParamMap.get("agreementType");
        this._userTicket = this._activatedRoute.snapshot.queryParamMap.get("ticket");
    }

    getAgreement(){
        this._accountService.userAgreement_Get(this._agreementType)
            .subscribe(q => {
                this.agreement = q;
                this.userAgreementContainer.nativeElement.innerHTML = q.text;
            });
    }

    public acceptButtonClick(event: Event): void {
        const navigateUri = this._isAuthorized ? './userAgreementAuthorized' : './userAgreement';

        this._accountService.userAgreement_Accept(this.agreement.id, this._userTicket, this._isAuthorized)
            .subscribe(q => {
                if (q.success) {
                    if(!q.data.needUserAgreement && !q.data.needUserAgreementSecond){
                        window.location.href = this._returnUrl;
                    }
                    else if(q.data.needUserAgreement){
                        this._router.navigate([navigateUri],
                            {
                                queryParams: {
                                    agreementType: AgreementType.Main,
                                    userTicket: this._userTicket
                                },
                                queryParamsHandling: 'merge'
                            }).then(res => {
                            if(res){
                                this.initAgreementType();
                                this.getAgreement();
                            }
                        })
                    }
                    else if(q.data.needUserAgreementSecond){
                        this._router.navigate([navigateUri],
                            {
                                queryParams: {
                                    agreementType: AgreementType.Second,
                                    userTicket: this._userTicket
                                },
                                queryParamsHandling: 'merge'
                            }).then(res => {
                                if(res){
                                    this.initAgreementType();
                                    this.getAgreement();
                                }
                        })

                    }
                } else {
                    console.log(q);
                }
            });
    }

    public rejectButtonClick(event: Event): void {
        window.location.href = this._returnUrl;
    }
}
